<template>
  <div class="results-section" id="the-results">
    <h2>{{ title }}</h2>
    <p class="description" v-if="showDescription">{{ description }}</p>
    <ul class="outcomes">
      <li v-for="(outcome, index) in outcomes" :key="index">
        <span class="outcome-title">{{ getOutcomeTitle(outcome) }}</span>
        {{ getOutcomeDescription(outcome) }}
      </li>
    </ul>
    <h3 class="subtitle">{{ subtitle }}</h3>
    <ul class="outcomes">
      <li v-for="(mesureableOutcome, index) in measureableOutcomes" :key="index">
        <span class="outcome-title">{{ getOutcomeTitle(mesureableOutcome) }}</span>
        {{ getOutcomeDescription(mesureableOutcome) }}
      </li>
    </ul>

    <p class="summary">{{ summary }}</p>
    <div class="watermark">
      Powered by <span :style="{ color: divacsColor, fontWeight: 'bold' }">{{ watermarkText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultsSection',
  props: {
    title: String,
    description: String,
    outcomes: Array,
    subtitle: String,
    measureableOutcomes: Array,
    summary: String,
    divacsColor: {
      type: String,
      default: '#2196f3', // Default to blue, matching the design
    },
    watermarkText: {
      type: String,
      default: 'DIVACS', // Default to "DIVACS" if not provided
    },
    showDescription:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    getOutcomeTitle(outcome) {
      if(outcome.startsWith(':')){
        return '';
      }
      // Get the part before the colon and add the colon back
      const parts = outcome.split(':');
      return parts[0] + ':';
    },
    getOutcomeDescription(outcome) {

      if (outcome.startsWith(':')){
        return outcome.slice(1).trim();
      }
      // Get the part after the colon
      const parts = outcome.split(':');
      return parts.length > 1 ? parts[1].trim() : '';

    },
  },
};
</script>

<style scoped>
.results-section {
  padding: 40px 0;
  text-align: left;
  position: relative; /* For positioning the watermark */
  max-width: 1200px; /* Match the design's content width */
  margin: 0 auto; /* Center the content */
}

h2 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #1DE09E;
}

.outcomes {
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
}
.subtitle{
  margin: 2rem 0rem 1rem 0rem;
}

.outcomes li {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  position: relative;
  padding-left: 20px;
  line-height: 1.5;
}

.outcomes li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #333;
  font-size: 20px;
}

.outcome-title {
  font-weight: bold; /* Bold the part before the colon */
}

.summary {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 40px; /* Space for the watermark */
}
.description{
  margin-bottom: 10px;
}
/* Watermark Styles */
.watermark {
  position: absolute;
  bottom: 10px;
  right: 20px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  

  h2 {
    font-size: 32px;
  }

  .outcomes li {
    padding-left: 15px;
  }

  .outcomes li::before {
    font-size: 16px;
  }

 

  .watermark {
    font-size: 12px;
    right: 15px;
    bottom: 5px;
  }
}
</style>